import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Payload {
  reason: string;
}

export default (makeCall: MakeCall) => (userId: number, data: Payload) =>
  makeCall('POST', `${APIV2_URL}/user/${userId}/report`, { data });
